import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-help-support',
    templateUrl: './help-support.component.html',
    styleUrls: ['./help-support.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatIconModule
    ]
})
export class HelpSupportComponent implements OnInit {
  constructor(private readonly location: Location) {}

  ngOnInit(): void {}

  backAction() {
    this.location.back();
  }
}
